<template>
  <v-container>
    <material-card>
      <v-layout slot="header" px-3>
        <v-flex mt-2 pl-3 align-center justify-center>
          <div class="headline">Role</div>

          <p>Drzewo ról</p>
        </v-flex>
      </v-layout>

      <v-treeview ref="treeview" hoverable :items="tree" :open-all="true">
        <template v-slot:append="{ item }">
          <div>
            <check-permission permissions="ROLE.ADD">
              <v-btn icon flat color="primary" @click.stop="roleAdd(item.id)">
                <v-icon>mdi-plus-circle-outline</v-icon>
              </v-btn>
            </check-permission>

            <check-permission permissions="PERMISSION_RELATION.LIST">
              <router-link :to="{ name: 'rolePermission', params: { id: item.id } }">
                <v-btn icon flat>
                  <v-icon>mdi-account-key</v-icon>
                </v-btn>
              </router-link>
            </check-permission>

            <check-permission permissions="ROLE.UPDATE">
              <v-btn icon flat color="primary" @click.stop="roleUpdate(item.id, item.parent.id)">
                <v-icon>mdi-pencil-outline</v-icon>
              </v-btn>
            </check-permission>

            <check-permission permissions="ROLE.DELETE">
              <v-btn icon flat color="error" @click.prevent.stop="showDeleteDialog(item.id)">
                <v-icon>mdi-trash-can-outline</v-icon>
              </v-btn>
            </check-permission>
          </div>
        </template>
      </v-treeview>

      <material-dialog
        :id="idToDelete"
        title="Potwierdź usunięcie"
        text="Czy na pewno chcesz usunąć rolę?"
        :show="!!idToDelete"
        @close="hideDeleteDialog"
        @confirm="remove"
      />
    </material-card>

    <modal
      :id="idToEdit"
      :show="showModal"
      :edit="!!idToEdit"
      :parent-id="parentId"
      @close="hideModal"
      @save="add"
      @update="update"
    />
  </v-container>
</template>

<script>
import { mapState } from 'vuex';

import MaterialCard from '@/components/material/Card';
import MaterialDialog from '@/components/material/Dialog';
import { listMixin } from '@/mixins/list';
import Modal from './roleAdd.modal';
// @vuese
// Wyświetlanie drzewa ról
// @group Roles
export default {
  mixins: [
    listMixin('roles', {
      listError: 'Wystąpił błąd podczas pobierania listy ról.',
      getError: 'Wystąpił błąd podczas pobierania danych roli.',
      added: 'Dodano rolę.',
      addError: 'Nie udało się dodać roli.',
      updated: 'Zaktualizowano dane roli.',
      updateError: 'Nie udało się zaktualizować danych roli.',
      deleted: 'Usunięto rolę.',
      deleteError: 'Nie udało się usunąć roli.'
    })
  ],
  components: {
    MaterialCard,
    MaterialDialog,
    Modal
  },
  data() {
    return {
      parentId: undefined
    };
  },
  computed: mapState({
    tree(state) {
      const roles = state.roles.list.map(role => ({ ...role }));
      return roles.reduce((roots, role) => {
        if (!!role.parent) {
          this.addToParent(role, roles);
        } else {
          roots.push(role);
        }
        return roots;
      }, []);
    }
  }),
  methods: {
    // @vuese
    // Otwiera modal z dodawaniem roli
    roleAdd(parentId) {
      this.parentId = parentId;
      this.showAddModal();
    },
    // @vuese
    // Otwiera modal z aktualizacją roli
    roleUpdate(id, parentId) {
      this.parentId = parentId;
      this.showEditModal(id);
    },
    // @vuese
    // Ustawia rolę jako dziecko
    addToParent(role, roles) {
      const parent = roles.find(r => r.id === role.parent.id);
      if (parent.children) {
        parent.children.push(role);
      } else {
        parent.children = [role];
      }
    }
  }
};
</script>
